import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import SchoolHandoverForm from "./routes/SchoolHandoverForm";
export default store => {
  return {
    path: "school-handover",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "administrator-tooling" */ "./SchoolHandover"
          ),
          import(
            /* webpackChunkName: "administrator-tooling" */ "./modules/SchoolHandoverModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "schoolHandover",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [SchoolHandoverForm(store)],
  };
};
